export enum VIEW_OPTIONS {
  TABLE_VIEW = 'TABLE',
  CARD_VIEW = 'CARD',
}
